import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { clickToTalkEnabled } from "../../../featureToggle";
import Box from "./components/Box";
import Button from "./components/Button";
import { useChatbotService } from "./components/ChatbotService";
import ChatWindow from "./components/ChatWindow/ChatWindow";
import PreChatForm from "./components/ChatWindow/PreChatForm";
import useMessages from "./components/ChatWindow/useMessages";
import useThread from "./components/ChatWindow/useThread";
import Container from "./components/Container";
import { BubbleIcon } from "./components/Icons";
import { LiveagentChat } from "./components/SalesforceChatService";
import useLocalState from "./components/useLocalState";
var Page = function (props) {
    var _a, _b;
    var _c = useLocalState("chat-open", false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(null), handoff = _d[0], setHandoff = _d[1];
    var _e = useLocalState("pre-chat-data", undefined), preChatData = _e[0], setPreChatData = _e[1];
    var _f = useState(!!handoff), showLiveAgent = _f[0], setShowLiveAgent = _f[1];
    var _g = useState(props.assistantId), assistantId = _g[0], setAssistantId = _g[1];
    var _h = useState(props.uiLabels), uiLabels = _h[0], _setUiLabels = _h[1];
    var chatbotService = useChatbotService();
    var _j = useThread(), chatId = _j.chatId, resetThread = _j.resetThread, setChatId = _j.setChatId;
    var _k = useMessages(), messages = _k.messages, addMessage = _k.addMessage, resetMessages = _k.resetMessages, disableMessage = _k.disableMessage;
    var _l = useState(null), disableTimeout = _l[0], setDisableTimeout = _l[1];
    useEffect(function () {
        if (showLiveAgent) {
            resetMessages();
            resetThread();
        }
    }, [showLiveAgent]);
    useEffect(function () {
        if (!props.threadTimeout)
            return;
        if (messages.length === 0)
            return;
        var lastMessage = messages[messages.length - 1];
        if (!lastMessage)
            return;
        var timeSinceLastMessage = Date.now() - lastMessage.timestamp;
        if (timeSinceLastMessage > props.threadTimeout) {
            resetMessages();
            resetThread();
        }
    }, [props.threadTimeout, messages, resetThread, resetMessages]);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : "320px";
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : "498px";
    var onLiveagentClose = useCallback(function () {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "closeLiveAgent",
                event_category: "chatbot",
            });
        }
        setHandoff(null);
        setShowLiveAgent(false);
        setPreChatData(undefined);
        setIsOpen(false);
    }, [setHandoff, setPreChatData, setIsOpen]);
    var onLiveagentOpen = useCallback(function () {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "openLiveAgent",
                event_category: "chatbot",
            });
        }
        setIsOpen(false);
        setShowLiveAgent(true);
        if (disableTimeout) {
            clearTimeout(disableTimeout);
        }
    }, [disableTimeout]);
    var onAction = useCallback(function (action) {
        switch (action.type) {
            case "human-handoff":
                if (props.gtag)
                    props.gtag("event", "chatbot", {
                        event_label: "humanHandoff",
                        event_category: "chatbot",
                    });
                if (clickToTalkEnabled)
                    return;
                setHandoff(action);
                break;
            case "navigate-to-products":
                if (props.gtag)
                    props.gtag("event", "chatbot", {
                        event_label: "navigateToProduct",
                        event_category: "chatbot",
                    });
                window.sessionStorage.setItem("lookup-availability-check-data", JSON.stringify(action.lookupData));
                if (window.innerWidth <= 768) {
                    setTimeout(function () {
                        setIsOpen(false);
                        window.location.href = "/broadband/broadband-results";
                    }, 2500);
                }
                else {
                    window.location.href = "/broadband/broadband-results";
                }
                break;
            case "upgrade-products":
                if (window.innerWidth <= 768) {
                    setTimeout(function () {
                        setIsOpen(false);
                        window.location.href = "/upgrade/".concat(action.serviceId);
                    }, 2500);
                }
                else {
                    window.location.href = "/upgrade/".concat(action.serviceId);
                }
                break;
            default:
                break;
        }
    }, [setHandoff]);
    var onButtonClick = useCallback(function () {
        window.dataLayer = window.dataLayer || [];
        var eventData = {
            event: "gtm-chatbot-open-chat",
            session_id: new Date().getTime(),
            requestStatus: "gtm-chatbot-open-chat",
        };
        window.dataLayer.push(eventData);
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "openChat",
                event_category: "chatbot",
            });
        }
        setIsOpen(true);
    }, [setIsOpen]);
    var onPreChatSubmit = useCallback(function (data) {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "preChatSubmit",
                event_category: "chatbot",
            });
        }
        setPreChatData(data);
    }, [setPreChatData, setAssistantId, props.gtag]);
    var onClose = useCallback(function () {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "closeChat",
                event_category: "chatbot",
            });
        }
        setIsOpen(false);
        setPreChatData(undefined);
    }, [setIsOpen, setPreChatData]);
    var onPreChatClose = useCallback(function () {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "preChatClose",
                event_category: "chatbot",
            });
        }
        setIsOpen(false);
    }, [setIsOpen, setPreChatData]);
    var onMinimize = useCallback(function () {
        if (props.gtag) {
            props.gtag("event", "chatbot", {
                event_label: "minimizeChat",
                event_category: "chatbot",
            });
        }
        setIsOpen(false);
    }, [setIsOpen]);
    return (_jsxs(_Fragment, { children: [handoff ? (_jsx(LiveagentChat, { caseId: handoff === null || handoff === void 0 ? void 0 : handoff.caseId, transcriptId: handoff === null || handoff === void 0 ? void 0 : handoff.transcriptId, department: handoff === null || handoff === void 0 ? void 0 : handoff.department, accountId: (handoff === null || handoff === void 0 ? void 0 : handoff.accountId) || "", firstName: (preChatData === null || preChatData === void 0 ? void 0 : preChatData.firstName) || props.firstName || "", lastName: (preChatData === null || preChatData === void 0 ? void 0 : preChatData.lastName) || props.lastName || "", email: (preChatData === null || preChatData === void 0 ? void 0 : preChatData.email) || props.email || "", onClose: onLiveagentClose, onOpen: onLiveagentOpen })) : null, !(handoff && showLiveAgent) ? (_jsx(Container, { children: isOpen ? (preChatData || props.isAuthenticated ? (_jsx(ChatWindow, { setChatId: setChatId, chatbotService: chatbotService, chatId: chatId, addMessage: addMessage, messages: messages, resetThread: resetThread, resetMessages: resetMessages, onClose: onClose, onMinimize: onMinimize, onAction: onAction, onHumanHandoff: function (index, action) {
                        setHandoff(action);
                        disableMessage(index, true);
                        var timeout = setTimeout(function () {
                            disableMessage(index, false);
                        }, 1000);
                        setDisableTimeout(timeout);
                    }, width: width, height: height, uiLabels: uiLabels, assistantId: assistantId, departments: props.departments, preChatData: preChatData, name: props.firstName })) : (_jsx(PreChatForm, { onSubmit: onPreChatSubmit, onClose: onPreChatClose, width: width, height: height, departments: props.departments, uiLabels: uiLabels }))) : (_jsx(Button, { onClick: onButtonClick, isFlatBottom: true, ariaLabel: "Chat Now", children: _jsxs(Box, { row: true, center: true, gap: "0.5em", children: [_jsx(BubbleIcon, { width: "1em", height: "1em", color: "var(--button-text-color)" }), props.uiLabels.buttonLabel] }) })) })) : null] }));
};
export default Page;
